import { memo } from 'react';

import { useTranslateFn } from '@shared/Translate';

const Legend = ({ rankCriteria }) => {
  const t = useTranslateFn();

  return (
    <div role='region' className='pk-container ts-ranking--legend' pk-theme='light'>
      <div className='pk-col pk-col--span-12 pk-col--span-lg-10 pk-col--offset-lg-1'>
        <span className='bold'>{t('ts_ranking_criteria')}</span>
        <span>{t(rankCriteria ? rankCriteria : 'ts_criteria_list')}</span>
        <span className='bold'>{t('ts_criteria_note')}</span>
        <span>{t('ts_note_desc')}</span>
      </div>
    </div>
  );
};

export default memo(Legend);
